<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import remoteLoad from "./assets/js/remoteLoad";
export default {
  data() {
    return {};
  },
  created() {
    let arr = this.regionList;
    this.getInfoByDomain().then(() => {
      for (let i in arr) {
        if (arr[i].id == this.platformData.region) {
          this.switchRegionIndex(i);
        }
      }
      //加载高德地图
      /*
      Promise.all([
        remoteLoad(
          "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding,AMap.PolyEditor"
        ),
      ]);
      */
      if (arr[this.currentRegion].id != "cn") {
        // 加载谷歌地图
        Promise.all([
          remoteLoad(
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
          )
        ]);
      } else {
        //加载高德地图
        Promise.all([
          remoteLoad(
            "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding,AMap.PolyEditor"
          ),
        ]);
      }
    });
  },
  computed: {
    ...mapState(["regionList", "currentRegion", "platformData"]),
  },
  methods: {
    ...mapActions(["getInfoByDomain"]),
    ...mapMutations(["setInfoByDomain", "switchRegionIndex"]),
  },
};
</script>

<style>
@import "./assets/css/reset.css";
@font-face {
  font-family: "DIN";
  src: url("./assets/fonts/DIN-BOLD.OTF");
}
:root {
  
  --primary-light: #8abdff;
  --primary: #6d5dfc;
  --primary-dark: #5b0eeb;
  --white: #ffffff;
  --greyLight-1: #e4ebf5;
  --greyLight-2: #c8d0e7;
  --greyLight-3: #bec8e4;
  --greyDark: #9baacf;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f4f6f9;
  /* background: var(--greyLight-1); */
  overflow: hidden;
}
.app-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* overflow: auto; */
  overflow-x: hidden;
  overflow-y: auto;
}
.from {
  float: left;
  display: flex;
  flex-wrap: wrap;
}

.from .el-form-item{
  margin-right: 20px;
}
/* .from .el-form-item__label-wrap{
  margin-left: 0 !important;
} */
/* .el-form-item{
  float: left;
} */
.search {
  margin-bottom: 20px;
}



.dilu-map-fence {
  width: 250px;
  height: 120px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.dilu-map-fence-top {
  display: flex;
  margin-bottom: 20px;
}

.dilu-map-fence-icon {
  width: 30px;
  height: 20px;
  border: 3px solid #1890ff;
  border-radius: 4px;
  position: relative;
  margin-right: 20px;
  flex-shrink: 0;
}

.dilu-map-fence-icon span {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1890ff;
}

.dilu-map-fence-icon span:nth-child(1) {
  top: 10px;
  left: -4px;
}

.dilu-map-fence-icon span:nth-child(2) {
  top: 10px;
  right: -4px;
}

.dilu-map-fence-icon span:nth-child(3) {
  top: -4px;
  left: 13px;
}

.dilu-map-fence-icon span:nth-child(4) {
  bottom: -4px;
  left: 13px;
}

.dilu-map-fence-title {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  flex: 1;
  width: 0;
  word-wrap:break-word;
}

.speed-limit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 15px;
  color: #9baacf;
  margin-bottom: 16px;
}

.dilu-map-fence-bottom {
  display: flex;
  justify-content: space-between;
}

.dilu-map-fence-bottom div:first-child {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  line-height: 15px;
  color: #000000;
}

.dilu-map-fence-bottom div:last-child {
  width: 70px;
  height: 24px;
  background: #1890ff;
  opacity: 1;
  border-radius: 10px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
